import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Question from "@/models/lms/Question";

export default class Answer extends GenexLMSModel {
    static entity = 'answers'

    static fields() {
        return {
            type: this.attr('answers'),
            id: this.attr(null),
            order: this.attr(0),
            question_id: this.attr(null),
            question: this.belongsTo(Question, 'question_id'),
            answer: this.attr(null),
            correct: this.attr(0),
        }
    }
}
